import type { NodeId } from '../../lib/types';
import type { AppState } from '../../store';

/**
 * The single choke point for a node's render-time y.
 *
 * Canonical `positions[id].y` normally; the ephemeral `displayY[id]` while the documentation
 * rows are expanded. `positions[id].y` is NEVER written by the display pass, which is what
 * makes zooming back out — or reloading — restore the exact saved compact layout, and what
 * stops a purely visual zoom gesture firing a `PUT /api/map`.
 *
 * The vanilla original is one line and says the same thing; it is worth its own module here
 * only because four different consumers need it (the node, the wires, hit-testing and the
 * camera) and a second copy of `docsExpanded && displayY[id] !== undefined` in any of them is
 * how the map would come apart along that seam.
 */
export function posY(s: Pick<AppState, 'docsExpanded' | 'displayY' | 'positions'>, id: NodeId): number {
  if (s.docsExpanded && s.displayY[id] !== undefined) return s.displayY[id];
  return s.positions[id]?.y ?? 0;
}
